/**
 * Checks if a given language code corresponds to a Right-to-Left (RTL) language.
 * @param language The language code (e.g., 'en', 'ar').
 * @returns True if the language is RTL, false otherwise.
 */
export function isRtl(language: string | null | undefined): boolean {
  if (!language) return false;
  return [
    "ar", // Arabic
    "arc", // Aramaic
    "dv", // Divehi
    "fa", // Persian (Farsi)
    "ha", // Hausa (Arabic script)
    "he", // Hebrew
    "khw", // Khowar
    "ks", // Kashmiri
    "ku", // Kurdish (Sorani variant)
    "ps", // Pashto
    "ur", // Urdu
    "yi", // Yiddish
  ].includes(language);
}
